import CancelAmendConfirmation from '../../../components/sections/osb-v3/cancel-amend-confirmation/cancel-amend-confirmation';

export function CancelConfirmStepView() {
    return (
        <div className="osb-v3-cancel-amend-confirmation-view-container">
            <CancelAmendConfirmation />
        </div>
    );
}
